"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectPath = exports.ObjectPathError = void 0;
class ObjectPathError extends Error {
    constructor(msg = "") {
        super(msg);
    }
}
exports.ObjectPathError = ObjectPathError;
const getObjectPath = (obj, path, throwOnError = true) => {
    const props = path.split(".").filter(p => p !== "");
    return props.reduce((o, k) => {
        if (typeof o !== "object" || !o.hasOwnProperty(k)) {
            if (throwOnError) {
                throw new ObjectPathError(path);
            }
            return undefined;
        }
        return o[k];
    }, obj);
};
exports.getObjectPath = getObjectPath;
//# sourceMappingURL=util.js.map